/**
 * Types de véhicule alignés sur l’app mobile (`mobile-frontend/utils/localVehicleTypes.js`)
 * et `mover_profiles.vehicle_type` / `truck_type` côté backend.
 */
export const TRUCK_TYPES = {
  fourgounette: {
    label: 'Fourgounette',
    volume: 8,
    teamSize: 2,
    hourlyRate: 110,
    aliases: ['fourgounette', 'fourgonnette', 'fourgonette'],
  },
  grand_fourgon: {
    label: 'Grand Fourgon',
    volume: 15,
    teamSize: 2,
    hourlyRate: 125,
    aliases: ['grand_fourgon', 'grand fourgon', 'fourgon', '12m3', '10m3', 'petit camion'],
  },
  camion_caisse: {
    label: 'Camion Caisse',
    volume: 22,
    teamSize: 3,
    hourlyRate: 145,
    aliases: [
      'camion_caisse',
      'camion caisse',
      'camion_20m3',
      'camion 20m3',
      'camion 20m³',
      '20m3',
      '20m³',
      '20',
      'moyen camion',
    ],
  },
  simple_cabine: {
    label: 'Simple Cabine',
    volume: 35,
    teamSize: 4,
    hourlyRate: 170,
    aliases: [
      'simple_cabine',
      'simple cabine',
      'simlpe cabine',
      'camion_30m3',
      'camion 30m3',
      'camion 30m³',
      '30m3',
      '30m³',
      '30',
      'grand camion',
      'poids lourd',
      '40m3',
      '50m3',
      '40',
      '50',
    ],
  },
};

/** Anciens libellés / slugs web → clé canonique (aligné app). */
export const LEGACY_TRUCK_LABEL_TO_KEY = {
  fourgon: 'grand_fourgon',
  camion_20m3: 'camion_caisse',
  camion_30m3: 'simple_cabine',
  poids_lourd: 'simple_cabine',
};

export const DEFAULT_RADIUS_KM = 15;
export const DEFAULT_SORT_BY = 'distance';
